import { GetterTree } from 'vuex'
import SosState from './states'
import { State } from '@/store/store'

const getters: GetterTree<SosState, State> = {
  headerLists: (state) => {
    return state.list.column
  },
  sosLists: (state) => {
    const data = state.list.result
    const result: Array<{
      text?: string,
      value?: string,
    }> = []
    data.forEach((each) => {
      result.push({
        text: each.name,
        value: each._id,
      })
    })
    return result
  },
  itemLists: (state) => {
    return state.list.result
  },
  filterLists: (state) => {
    return state.list.defaultFilter
  },
  pagination: (state) => {
    const paginationLists = {
      itemCount: state.list.itemCount,
      page: state.list.page,
      pageCount: state.list.pageCount,
    }
    return paginationLists
  },
}

export default getters
